import type { ComponentType } from 'react'

import { useLoading } from '../Loading'
import { PlaceholderInternal } from '../Placeholder/PlaceholderInternal'

type Props<T> = {
	placeholderLines?: number
	placeholderWidth?: number | string
	className?: string
	value?: T extends { value: any } ? T['value'] : never
} & Omit<T, 'value'>

export const wrapper = <TProps extends Record<string, any>>(
	Component: ComponentType<TProps>,
): ComponentType<Props<TProps>> => {
	const WrappedFormatter = ({ placeholderLines, placeholderWidth, className, ...props }: Props<TProps>) => {
		const isLoading = useLoading()
		if (isLoading) {
			return <PlaceholderInternal lines={placeholderLines} width={placeholderWidth} className={className} />
		}
		return <Component {...(props as TProps)} />
	}

	WrappedFormatter.displayName = `Placeholder(${Component?.displayName || Component?.name || 'Formatted'})`

	return WrappedFormatter
}
